module.exports = new __parcel__URL__("castle.cddd126d.webp").toString();